/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.formatter

import kotlinx.coroutines.flow.StateFlow
import studio.oddpods.cauce.core.model.UserData
import kotlin.math.absoluteValue

class CurrencyFormatter(
    private val prefs: StateFlow<UserData>,
) {
    fun format(centavos: Long): String {
        val current = prefs.value.displayPreferences
        val isNegative = centavos < 0L
        val abs = centavos.absoluteValue
        val pesos = abs / 100
        val cents = abs % 100

        val pesosStr = if (current.useThousandsSeparator) {
            pesos.toString().reversed().chunked(3).joinToString(".").reversed()
        } else {
            pesos.toString()
        }

        val rounded = if (!current.showDecimals && cents >= 50) pesosStr.incrementLastDigit() else pesosStr
        val sign = if (isNegative) "-" else ""

        return if (current.showDecimals) {
            "$sign\$$pesosStr,${cents.toString().padStart(2, '0')}"
        } else {
            "$sign\$$rounded"
        }
    }

    fun parse(input: String): Long? {
        val cleaned = input.replace("$", "").replace(".", "").replace(",", ".").trim()
        val parsed = cleaned.toDoubleOrNull() ?: return null
        return (parsed * 100).toLong()
    }

    private fun String.incrementLastDigit(): String {
        val asLong = replace(".", "").toLongOrNull() ?: return this
        val incremented = asLong + 1
        val useSep = this.contains('.')
        return if (useSep) {
            incremented.toString().reversed().chunked(3).joinToString(".").reversed()
        } else {
            incremented.toString()
        }
    }
}
